interface Routes {
  MIGRATION: string;
}

export const ROUTES: Routes = {
  MIGRATION: '/migration',
};
